import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook to update the document title
 * @param {string} title - The title to set for the document
 * @param {boolean} [includeAppName=true] - Whether to include the app name in the title
 */
const useDocumentTitle = (title, includeAppName = true) => {
  const { t } = useTranslation('hooks');

  useEffect(() => {
    // Get the app name from the environment or use a default
    const appName = import.meta.env.VITE_APP_NAME || t('documentTitle.defaultTitle');

    // Set the document title with or without the app name
    document.title = includeAppName ? `${title} | ${appName}` : title;

    // Restore the original title when the component unmounts
    return () => {
      document.title = appName;
    };
  }, [title, includeAppName, t]);
};

export default useDocumentTitle;
